function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Layer 1",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M67.19 71.51h-16.2V87.7H34.8v16.2h16.19v16.19h16.2V103.9h16.2V87.7h-16.2V71.51z"
}), React.createElement("path", {
  d: "M59.14 0L0 74.17h25.06v77.47h68.06V74.17h25.06zm31 71.17v77.47H28.06V71.17H6.23L59.14 4.81 112 71.17z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 118.18 151.64"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/treatment.svg";
export { SvgComponent as ReactComponent };